<div class="policy-outer">
    <div class="policy-wraper custom-terms-condition">
        <div class="logo-inner">
            <img src="assets/images/terms-logo.png" alt="Terms logo"/>
        </div>
        <h2>Privacy Policy </h2>
        <h4>Last updated: March 6, 2024
        </h4>

<div class="pricing-outer">

            <p>At Trucklots, we value the privacy of our users and are committed to protecting it. This Privacy Policy
                outlines our practices regarding the collection, use, and disclosure of personal information when you
                use our website and the choices you have associated with that information.</p>
            <p>By using the Trucklots website, you agree to the collection and use of information in accordance with
                this policy. If you disagree with any aspect of this policy, please do not use our website. </p>

        </div>

        <div class="pricing-outer">
            <h3>Information Collection and Use </h3>
            <p>We collect several different types of information for various purposes to provide and improve our service
                to you. </p>
            <h4>Types of Data Collected </h4>
            <p><b>Personal Data:</b> While using our website, we may ask you to provide us with certain personally
                identifiable information that can be used to contact or identify you ("Personal Data"). Personally
                identifiable information may include, but is not limited to:</p>
        </div>
        <div class="pricing-outer">
            <div class="p-outer">
                <span class="built"></span>
                <p>Email</p>
            </div>
            <div class="p-outer">
                <span class="built"></span>
                <p>First name and last name </p>
            </div>
            <div class="p-outer">
                <span class="built"></span>
                <p>Mobile Number</p>
            </div>
            <div class="p-outer">
                <span class="built"></span>
                <p>Address, State, Province, ZIP/Postal code, City</p>
            </div>
            <div class="p-outer">
                <span class="built"></span>
                <p>Cookies and Usage Data </p>
            </div>

        </div>
        <div class="pricing-outer">

            <p><b>Usage Data:</b> We may also collect information on how the website is accessed and used ("Usage
                Data"). </p>
        </div>

    </div>

</div>